import CreateAppointmentPage from './CreateAppointmentPage';
import AppointmentDetailsPage from './AppointmentDetailsPage';
import MyAppointmentsPage from './MyAppointmentsPage';

export default [
  {
    name: 'guest-appointment-details',
    path: '/appointments/:appointmentId',
    props: { isPublic: true },
    component: AppointmentDetailsPage,
    meta: {
      requiresAuth: false,
      title: 'Appointment Details',
      hideSidebar: true
    }
  },
  {
    name: 'create-appointment',
    path: '/warehouse/:warehouseId/schedule',
    props: true,
    component: CreateAppointmentPage,
    meta: {
      requiresAuth: true,
      title: 'Book Appointment',
      hideSidebar: false
    }
  },
  {
    name: 'my-appointments',
    path: '/warehouse/:warehouseId/appointments',
    props: true,
    component: MyAppointmentsPage,
    meta: {
      requiresAuth: true,
      title: 'My Appointment',
      hideSidebar: true
    }
  },
  {
    name: 'appointment-details',
    path: '/warehouse/:warehouseId/appointments/:appointmentId',
    props: true,
    component: AppointmentDetailsPage,
    meta: {
      requiresAuth: true,
      title: 'Appointment Details',
      hideSidebar: true
    }
  }
];
